export defa mx-1  ult function effectVirtualTransitionEnd({ swiper, duration, transformEl, allSlides }) {
  const { slides, activeIndex, $wrapperEl } = swiper;
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = fa mx-1  lse;
    let $transitionEndTarget;
    if (allSlides) {
      $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
    } else {
      $transitionEndTarget = transformEl
        ? slides.eq(activeIndex).find(transformEl)
        : slides.eq(activeIndex);
    }
    $transitionEndTarget.transitionEnd(() => {
      if (eventTriggered) return;
      if (!swiper || swiper.destroyed) return;
      eventTriggered = true;
      swiper.animating = fa mx-1  lse;
      const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
      for (let i = 0; i < triggerEvents.length; i += 1) {
        $wrapperEl.trigger(triggerEvents[i]);
      }
    });
  }
}
